import * as page_height from "./page_height";
import * as footer from "./footer";

export function watch() {

    let form = document.querySelector('#MemberGetresetpasswordForm');

    if(form == null) {
        return;
    }

    // Ajout des attributes "required" et des astérisques
    Array.prototype.forEach.call(document.getElementsByClassName('input required'), function (elm) {
        let input = elm.querySelectorAll('input, select');
        if (input[0] != null) {
            input[0].setAttribute("required", "");
            let label = input[0].parentElement.parentElement.parentElement.getElementsByTagName('label');
            if(label[0] != null) {
                label[0].innerText = label[0].innerText.trim() + ' *';
            }
        }
    });

    // Bouton de validation
    let bouton = form.querySelector('[type="submit"]');
    bouton.setAttribute('disabled', '');

    // Vérification de la complétion des champs requis
    let input_events = ['keyup', 'copy', 'paste', 'cut', 'change', 'select', 'input'];
    let inputs = form.querySelectorAll('input[required], select[required], input[type="checkbox"]');

    // Anti emmerdeurs
    bouton.addEventListener('click', function () {
        button_state(check_required_inputs(inputs), bouton);
    });

    // Event sur tous les champs requis
    input_events.forEach(function (event) {
        Array.prototype.forEach.call(inputs, function (elm) {
            elm.addEventListener(event, function () {
                button_state(check_required_inputs(inputs), bouton);
            });
        });
    });

    button_state(check_required_inputs(inputs), bouton);

    return true;
}

function button_state(state, bouton) {
    if(state) {
        bouton.removeAttribute('disabled');
        bouton.removeAttribute('title');
    } else {
        bouton.setAttribute('disabled', '');
        bouton.setAttribute('title', 'Le formulaire est invalide');
    }
}

function check_required_inputs(inputs) {

    let result = true;

    if(inputs != null && inputs.length > 0) {
        inputs.forEach(function (elm) {

            if(elm.getAttribute('type') === "checkbox") {

                if (!elm.checked) {
                    result = false;
                }

            } else {

                if (elm.value.trim().length < 1) {
                    result = false;
                }
            }
        })
    }

    return result;
}